import React from 'react';
import type { FC } from 'react';
import type { SidebarMenuItem } from '../classes/SidebarMenuItem';
import { Block } from '@klp/design';

import {
    Divider,
    ListItem,
    ListItemIcon,
    ListItemText,
} from '@material-ui/core';

import { Link as RouteLink } from 'react-router-dom';
import { useAppParams } from '@forvalter/packages/appParams/useAppParams';
import { contextSelectors } from '@klp/contextSelector';
import { useSelector } from 'react-redux';
import { Illustration } from '@klp/design/Illustrations';
import { useTranslation } from 'react-i18next';
import { useCurrentUser } from '@klp/auth';
import { useLayoutContext } from '@klp/layout/Layout/LayoutContext';

export type SidebarMenuDynamicItemProps = {
    sidebarItem: SidebarMenuItem;
};

export const SidebarMenuDynamicItem: FC<SidebarMenuDynamicItemProps> = ({
    sidebarItem,
}) => {
    const { t } = useTranslation();
    const { matchRoute } = useAppParams();
    const { selectedContext } = useSelector(contextSelectors);
    const { setMenuOpen } = useLayoutContext();
    const handleDrawerClose = () => {
        setMenuOpen(false);
    };
    const { currentUser } = useCurrentUser();

    const { access, condition } = sidebarItem;
    if (access && access?.(currentUser) === false) return null;
    if (condition && !condition?.(sidebarItem)) return null;

    return (
        <>
            {sidebarItem.divider && (
                <Block marginVertical="tiny">
                    <Divider />
                </Block>
            )}

            {!sidebarItem.divider && (
                <ListItem
                    button={true}
                    {...{
                        component: RouteLink,
                        to: sidebarItem.route,
                    }}
                    selected={matchRoute(sidebarItem.matchRoute || '')}
                    onClick={() => {
                        sidebarItem?.callback?.(selectedContext);
                        handleDrawerClose();
                    }}
                >
                    <ListItemIcon>
                        {sidebarItem.pictogram && (
                            <Illustration pictogram={sidebarItem.pictogram} />
                        )}
                        {sidebarItem.icon && (
                            <Illustration
                                icon={sidebarItem.icon}
                                klpColor="veryLight"
                                klpPalette="primary"
                            />
                        )}
                    </ListItemIcon>
                    <ListItemText primary={t(sidebarItem.translation || '')} />
                </ListItem>
            )}
        </>
    );
};
